module.exports = __webpack_public_path__ + "static/media/US.fa563627.svg";